import { on } from '@ember/modifier';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didInsert from '@ember/render-modifiers/modifiers/did-insert';
// eslint-disable-next-line ember/no-at-ember-render-modifiers
import didUpdate from '@ember/render-modifiers/modifiers/did-update';
import Component from '@glimmer/component';

interface RecordSelectSelectAllSignature {
  Args: {
    models: unknown[];
    onDeselectAll: () => void;
    onSelectAll: () => void;
    selectedModels: unknown[];
  };
  Element: HTMLInputElement;
}

export default class RecordSelectSelectAll extends Component<RecordSelectSelectAllSignature> {
  // Not @tracked — only read imperatively in syncIndeterminate, never in the template
  checkbox: HTMLInputElement | null = null;

  get checked(): boolean {
    const selected = this.args.selectedModels?.length ?? 0;
    const total = this.args.models?.length ?? 0;
    return selected > 0 && selected === total;
  }

  get indeterminate(): boolean {
    const selected = this.args.selectedModels?.length ?? 0;
    const total = this.args.models?.length ?? 0;
    return selected > 0 && selected < total;
  }

  handleInsert = (element: HTMLInputElement): void => {
    this.checkbox = element;
    this.syncIndeterminate();
  };

  syncIndeterminate = (): void => {
    if (this.checkbox) {
      this.checkbox.indeterminate = this.indeterminate;
    }
  };

  handleInput = (event: Event): void => {
    const target = event.target as HTMLInputElement;
    if (target.checked) {
      this.args.onSelectAll();
    } else {
      this.args.onDeselectAll();
    }
  };

  <template>
    <input
      type="checkbox"
      checked={{this.checked}}
      class="mx-1"
      {{didInsert this.handleInsert}}
      {{didUpdate this.syncIndeterminate this.indeterminate}}
      {{on "input" this.handleInput}}
      ...attributes
    />
  </template>
}
